export const eventTypeGradients = {
  program: {
    gradient: 'linear-gradient(135deg, rgba(0, 188, 212, 0.2) 0%, rgba(32, 178, 170, 0.2) 100%)',
    border: 'rgba(0, 188, 212, 0.3)',
    hover: 'linear-gradient(135deg, rgba(0, 188, 212, 0.3) 0%, rgba(32, 178, 170, 0.3) 100%)'
  },
  fundraising: {
    gradient: 'linear-gradient(135deg, rgba(124, 77, 255, 0.2) 0%, rgba(100, 149, 237, 0.2) 100%)',
    border: 'rgba(124, 77, 255, 0.3)',
    hover: 'linear-gradient(135deg, rgba(124, 77, 255, 0.3) 0%, rgba(100, 149, 237, 0.3) 100%)'
  },
  administrative: {
    gradient: 'linear-gradient(135deg, rgba(0, 150, 136, 0.2) 0%, rgba(38, 166, 154, 0.2) 100%)',
    border: 'rgba(0, 150, 136, 0.3)',
    hover: 'linear-gradient(135deg, rgba(0, 150, 136, 0.3) 0%, rgba(38, 166, 154, 0.3) 100%)'
  }
};

export const programTypeGradients = {
  // ... existing program type gradients ...
}; 